import style from "./Industry.module.css";
import industrytitle1 from "../../assets/images/industrytitle1.png";
import industry11 from "../../assets/images/industry11.png";
import request from "../../common/request";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Main() {
  const [list, setList] = useState([]);
  useEffect(() => {
    request.getArticleList(2, 1).then(function (result) {
      console.log(result);
      setList(result.data.data.data.slice(0, 5));
    });
  }, []);

  return (
    <>
      <div className={style.mainbox}>
        <img src={industrytitle1} />
        <div className={style.content}>
          <div>
            <img src={industry11} style={{ width: "100%" }} />
          </div>

          {list.map((item, index) => (
            <div className={style.article} key={index}>
              <Link to={`/article/` + item.id}>
                <div className={style.aleft}>
                  <h5>
                    {" "}
                    {item.created_at.split(" ")[0].split("-")[1]}.
                    {item.created_at.split(" ")[0].split("-")[2]}
                  </h5>
                  <label>{item.created_at.split(" ")[0].split("-")[0]}</label>
                </div>
                <div className={style.aright}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
